import { render, staticRenderFns } from "./phoneNews.vue?vue&type=template&id=b62bd1b0&scoped=true"
import script from "./phoneNews.vue?vue&type=script&lang=js"
export * from "./phoneNews.vue?vue&type=script&lang=js"
import style0 from "./phoneNews.vue?vue&type=style&index=0&id=b62bd1b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62bd1b0",
  null
  
)

export default component.exports